module.exports = __webpack_public_path__ + "static/media/Home.b5596ac2.jpg";